import { useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardConsultationsTable from './DashboardConsultationsTable/DashboardConsultationsTable';
import Modal from '../../../../commons/Modal/Modal';

export default () => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <DashboardLayout>
        <DashboardConsultationsTable />
      </DashboardLayout>
      <Modal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside>
        DashboardProspectsForm
      </Modal>
    </>
  );
};
